export const BADGES = {
    SALE: 131,
    PREMIUM: 127,
    NEW_ARRIVAL: 71,
    RATED: 231,
    ECO_CONSCIOUS: 512,
    WEEKEND: 187,
    HTO: 'hto',
};
